module.exports = __webpack_public_path__ + "img/1440.0caf6bd2.jpg";